import { create } from 'zustand'

type ModerationVariant = 'upload' | 'prompt'

interface ModerationDialogStore {
  open: boolean
  variant: ModerationVariant
}

export const useModerationDialogStore = create<ModerationDialogStore>(() => ({
  open: false,
  variant: 'upload',
}))

export function openUploadModerationDialog() {
  useModerationDialogStore.setState({ open: true, variant: 'upload' })
}

export function openPromptModerationDialog() {
  useModerationDialogStore.setState({ open: true, variant: 'prompt' })
}

export function closeModerationDialog() {
  useModerationDialogStore.setState({ open: false })
}
